// eslint-disable-next-line import/no-extraneous-dependencies
import { handleActions } from 'redux-actions';

import * as Actions from './actions';

const initialState = {
  // Get All Product
  isFirstGetAllProducts: false,
  isGetAllProductsRequest: false,
  isGetAllProductsSuccess: false,
  isGetAllProductsFailure: false,
  getAllProductsState: {},
  // Get Detail Product
  isGetDetailProductRequest: false,
  isGetDetailProductSuccess: false,
  isGetDetailProductFailure: false,
  getDetailProductState: {},

  // Create Product
  isCreateProductRequest: false,
  isCreateProductSuccess: false,
  isCreateProductFailure: false,
  // Update Product
  isUpdateProductRequest: false,
  isUpdateProductSuccess: false,
  isUpdateProductFailure: false,
  // Delete Product
  isDeleteProductRequest: false,
  isDeleteProductSuccess: false,
  isDeleteProductFailure: false,
  // Get List Categories
  isGetListCategoriesRequest: false,
  isGetListCategoriesSuccess: false,
  isGetListCategoriesFailure: false,
  getListCategoriesState: {},
  // Get List Products
  isGetListProductsRequest: false,
  isGetListProductsSuccess: false,
  isGetListProductsFailure: false,
  getListProductsState: {},

  // Get Products Scanner
  isGetProductsScannerRequest: false,
  isGetProductsScannerSuccess: false,
  isGetProductsScannerFailure: false,
  getProductsScannerState: {},
  // Create Product
  isImportFileExcelProductRequest: false,
  isImportFileExcelProductSuccess: false,
  isImportFileExcelProductFailure: false,
  // Search Product
  isSearchProductsRequest: false,
  isSearchProductsSuccess: false,
  isSearchProductsFailure: false,
  searchProductsState: {},
  // Local
  errorMessages: [],
};

const reducer = handleActions(
  {
    // #region : Get All Product
    [Actions.getAllProductsRequest]: (state) => ({
      ...state,
      isGetAllProductsRequest: true,
      isGetAllProductsSuccess: false,
      isGetAllProductsFailure: false,
    }),
    [Actions.getAllProductsSuccess]: (state, { payload }) => ({
      ...state,
      isFirstGetAllProducts: true,
      isGetAllProductsRequest: false,
      isGetAllProductsSuccess: true,
      isGetAllProductsFailure: false,
      getAllProductsState: payload?.append
        ? {
          ...payload,
          data: [
            ...(state.getAllProductsState?.data || []),
            ...payload.data.filter(
              (newItem) => !(state.getAllProductsState?.data || []).find(
                (oldItem) => oldItem.id === newItem.id,
              ),
            ),
          ],
        }
        : payload,
    }),
    [Actions.getAllProductsFailure]: (state, { payload }) => ({
      ...state,
      isGetAllProductsRequest: false,
      isGetAllProductsSuccess: false,
      isGetAllProductsFailure: true,
      errorMessages: payload,
    }),
    // #endregion
    // #region : Get Detail Product
    [Actions.getDetailProductRequest]: (state) => ({
      ...state,
      isGetDetailProductRequest: true,
      isGetDetailProductSuccess: false,
      isGetDetailProductFailure: false,
    }),
    [Actions.getDetailProductSuccess]: (state, { payload }) => ({
      ...state,
      isGetDetailProductRequest: false,
      isGetDetailProductSuccess: true,
      isGetDetailProductFailure: false,
      getDetailProductState: payload,
    }),
    [Actions.getDetailProductFailure]: (state, { payload }) => ({
      ...state,
      isGetDetailProductRequest: false,
      isGetDetailProductSuccess: false,
      isGetDetailProductFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetDetailProduct]: (state) => ({
      ...state,
      isGetDetailProductRequest: false,
      isGetDetailProductSuccess: false,
      isGetDetailProductFailure: false,
      getDetailProductState: {},
    }),
    // #endregion
    // #region : Create Product
    [Actions.createProductRequest]: (state) => ({
      ...state,
      isCreateProductRequest: true,
      isCreateProductSuccess: false,
      isCreateProductFailure: false,
    }),
    [Actions.createProductSuccess]: (state) => ({
      ...state,
      isCreateProductRequest: false,
      isCreateProductSuccess: true,
      isCreateProductFailure: false,
    }),
    [Actions.createProductFailure]: (state, { payload }) => ({
      ...state,
      isCreateProductRequest: false,
      isCreateProductSuccess: false,
      isCreateProductFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetCreateProduct]: (state) => ({
      ...state,
      isCreateProductRequest: false,
      isCreateProductSuccess: false,
      isCreateProductFailure: false,
      errorMessages: [],
    }),
    // #endregion
    // #region : Update Product
    [Actions.updateProductRequest]: (state) => ({
      ...state,
      isUpdateProductRequest: true,
      isUpdateProductSuccess: false,
      isUpdateProductFailure: false,
    }),
    [Actions.updateProductSuccess]: (state) => ({
      ...state,
      isUpdateProductRequest: false,
      isUpdateProductSuccess: true,
      isUpdateProductFailure: false,
    }),
    [Actions.updateProductFailure]: (state, { payload }) => ({
      ...state,
      isUpdateProductRequest: false,
      isUpdateProductSuccess: false,
      isUpdateProductFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetUpdateProduct]: (state) => ({
      ...state,
      isUpdateProductRequest: false,
      isUpdateProductSuccess: false,
      isUpdateProductFailure: false,
      errorMessages: [],
    }),
    // #endregion
    // #region : Delete Product
    [Actions.deleteProductRequest]: (state) => ({
      ...state,
      isDeleteProductRequest: true,
      isDeleteProductSuccess: false,
      isDeleteProductFailure: false,
    }),
    [Actions.deleteProductSuccess]: (state) => ({
      ...state,
      isDeleteProductRequest: false,
      isDeleteProductSuccess: true,
      isDeleteProductFailure: false,
    }),
    [Actions.deleteProductFailure]: (state, { payload }) => ({
      ...state,
      isDeleteProductRequest: false,
      isDeleteProductSuccess: false,
      isDeleteProductFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetDeleteProduct]: (state) => ({
      ...state,
      isDeleteProductRequest: false,
      isDeleteProductSuccess: false,
      isDeleteProductFailure: false,
      errorMessages: [],
    }),
    // #endregion
    // #region : Get List Categories
    [Actions.getListCategoriesRequest]: (state) => ({
      ...state,
      isGetListCategoriesRequest: true,
      isGetListCategoriesSuccess: false,
      isGetListCategoriesFailure: false,
    }),
    [Actions.getListCategoriesSuccess]: (state, { payload }) => ({
      ...state,
      isGetListCategoriesRequest: false,
      isGetListCategoriesSuccess: true,
      isGetListCategoriesFailure: false,
      getListCategoriesState: payload?.append
        ? {
          ...payload,
          data: [
            ...(state.getListCategoriesState?.data || []),
            ...payload.data.filter(
              (newItem) => !(state.getListCategoriesState?.data || []).find(
                (oldItem) => oldItem.id === newItem.id,
              ),
            ),
          ],
        }
        : payload,
    }),
    [Actions.getListCategoriesFailure]: (state, { payload }) => ({
      ...state,
      isGetListCategoriesRequest: false,
      isGetListCategoriesSuccess: false,
      isGetListCategoriesFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetGetListCategories]: (state) => ({
      ...state,
      isGetListCategoriesRequest: false,
      isGetListCategoriesSuccess: false,
      isGetListCategoriesFailure: false,
      getListCategoriesState: {},
      errorMessages: [],
    }),
    // #endregion
    // #region : Get List Products
    [Actions.getListProductsRequest]: (state) => ({
      ...state,
      isGetListProductsRequest: true,
      isGetListProductsSuccess: false,
      isGetListProductsFailure: false,
    }),
    [Actions.getListProductsSuccess]: (state, { payload }) => ({
      ...state,
      isGetListProductsRequest: false,
      isGetListProductsSuccess: true,
      isGetListProductsFailure: false,
      getListProductsState: payload,
    }),
    [Actions.getListProductsFailure]: (state, { payload }) => ({
      ...state,
      isGetListProductsRequest: false,
      isGetListProductsSuccess: false,
      isGetListProductsFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetGetListProducts]: (state) => ({
      ...state,
      isGetListProductsRequest: false,
      isGetListProductsSuccess: false,
      isGetListProductsFailure: false,
      getListProductsState: {},
      errorMessages: [],
    }),
    // #endregion
    // #region : Get Product scanner
    [Actions.getProductsScannerRequest]: (state) => ({
      ...state,
      isGetProductsScannerRequest: true,
      isGetProductsScannerSuccess: false,
      isGetProductsScannerFailure: false,
      getProductsScannerState: {},
    }),
    [Actions.getProductsScannerSuccess]: (state, { payload }) => ({
      ...state,
      isGetProductsScannerRequest: false,
      isGetProductsScannerSuccess: true,
      isGetProductsScannerFailure: false,
      getProductsScannerState: payload,
    }),
    [Actions.getProductsScannerFailure]: (state, { payload }) => ({
      ...state,
      isGetProductsScannerRequest: false,
      isGetProductsScannerSuccess: false,
      isGetProductsScannerFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetgetProductsScanner]: (state) => ({
      ...state,
      isGetProductsScannerRequest: false,
      isGetProductsScannerSuccess: false,
      isGetProductsScannerFailure: false,
      getProductsScannerState: {},
    }),

    // #endregion
    // #region : Import file excel product
    [Actions.importFileExcelProductRequest]: (state) => ({
      ...state,
      isImportFileExcelProductRequest: true,
      isImportFileExcelProductSuccess: false,
      isImportFileExcelProductFailure: false,
    }),
    [Actions.importFileExcelProductSuccess]: (state) => ({
      ...state,
      isImportFileExcelProductRequest: false,
      isImportFileExcelProductSuccess: true,
      isImportFileExcelProductFailure: false,
    }),
    [Actions.importFileExcelProductFailure]: (state, { payload }) => ({
      ...state,
      isImportFileExcelProductRequest: false,
      isImportFileExcelProductSuccess: false,
      isImportFileExcelProductFailure: true,
      errorMessages: payload,
    }),
    // #endregion
    // #region : Search Product
    [Actions.searchProductsRequest]: (state) => ({
      ...state,
      isSearchProductsRequest: true,
      isSearchProductsSuccess: false,
      isSearchProductsFailure: false,
    }),
    [Actions.searchProductsSuccess]: (state, { payload }) => ({
      ...state,
      isSearchProductsRequest: false,
      isSearchProductsSuccess: true,
      isSearchProductsFailure: false,
      searchProductsState: payload,
    }),
    [Actions.searchProductsFailure]: (state, { payload }) => ({
      ...state,
      isSearchProductsRequest: false,
      isSearchProductsSuccess: false,
      isSearchProductsFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetSearchProducts]: (state) => ({
      ...state,
      isSearchProductsRequest: false,
      isSearchProductsSuccess: false,
      isSearchProductsFailure: false,
      searchProductsState: {},
    }),
    // #endregion

    // #region : Local
    [Actions.resetProductState]: () => initialState,
    // #endregion
  },
  initialState,
);

export default reducer;
